import { render, staticRenderFns } from "./ExppointsList.vue?vue&type=template&id=b069d9ce&scoped=true"
import script from "./ExppointsList.vue?vue&type=script&lang=js"
export * from "./ExppointsList.vue?vue&type=script&lang=js"
import style0 from "./ExppointsList.vue?vue&type=style&index=0&id=b069d9ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b069d9ce",
  null
  
)

export default component.exports